import { MprcMessageBox, MprcRequestErrorReport, MprcRequestIndicator } from 'components';
import { DiscoverUserTrainingInfoResponse } from 'generated/CoreApi_v1';
import { useCoreApi } from 'providers/CoreApiProvider';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useParams } from 'react-router';
import { RootPaths } from 'routes/RootRouter';
import { NIL } from 'uuid';
import { resolveLmsTargetAction } from 'views/general/Cards/CardDtoActions';
import { ICardDtoPathResult } from 'views/general/Cards/Common';

///////////////////////////////////////////////////////////////////////////////

export const TrainingView = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const api = useCoreApi();
    const { t } = useTranslation("lms");
    const { trainingId = NIL, classroomId = undefined } = useParams();
    const [loading, setLoading] = useState<boolean>(true);
    const [viewError, setViewError] = useState<any>();
    const [viewData, setViewData] = useState<DiscoverUserTrainingInfoResponse>();
    const [dialog, setDialog] = useState<React.ReactNode | null>(null);
    const gobackUrl = useRef(location.state?.previousUrl ?? RootPaths.Home);

    //
    useEffect(() => {
        async function load() {
            try {
                var response = await api.v1.lmsTraining.discoverUserTrainingInfo({ trainingId: trainingId });
                setViewData(response.data);
            }
            catch (e) {
                setViewError(e);
            }
            finally {
                setLoading(false);
            }
        }
        if (loading) load();
    }, [trainingId]);

    ///
    const handleCloseDialog = () => {
        navigate(-1);
    };

    ///
    const handleNavigate = (pathResult: ICardDtoPathResult) => {
        navigate(pathResult.url, { state: { previousUrl: gobackUrl.current } });
    };

    const RenderContent = useMemo(() => {

        if (viewData == null)
            return <MprcMessageBox variant="error" message={t("TrainingView.NotFound")} onClose={handleCloseDialog} />;

        if (!viewData.isActive || viewData.isDeleted || !viewData.published)
            return <MprcMessageBox variant="error" message={t("TrainingView.TrainingNotAvailable")} onClose={handleCloseDialog} />;

        if (viewData.exclusiveLearnPathTraining)
            return <MprcMessageBox variant="error" message={t("TrainingView.ExclusiveLearnPathTraining")} onClose={handleCloseDialog} />;

        if (viewData.actions.length > 0) {
            viewData.data["targetClassroomId"] = classroomId;
            if (
                resolveLmsTargetAction(
                    viewData.actions[0],
                    viewData.data,
                    setDialog,
                    handleCloseDialog, handleCloseDialog, handleCloseDialog, handleNavigate)
            ) {
                return <></>;
            }
        }
        else {
            return <MprcMessageBox variant="error" message={t("TrainingView.NavigateError")} onClose={handleCloseDialog} />;
        }
    }, [viewData]);

    return (
        <>
            {loading
                ? <MprcRequestIndicator visible type="request" />
                : viewError != null
                    ? <MprcRequestErrorReport error={viewError} />
                    :
                    <>
                        {dialog}
                        {RenderContent}
                    </>
            }
        </>
    );
};
